module.exports = __webpack_public_path__ + "img/video4.a6b16ebb.jpg";